import { createAction, createReducer } from "@reduxjs/toolkit";

export const fetchAll = createAction("BLOGS_FETCH_ALL");

const initialState = {
  blogs: [],
};

const blogsReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchAll, (state, action) => {
    state.blogs = action.payload;
  });
});

export default blogsReducer;

export const blogsActions = {
  fetchAll,
};
